import Control from "../../1. Core/Control";
import NP from "../../1. Core/NP";
import Label from "../../1. Core/Controls/Label/Label";
import {Slice} from "./TechReport";
import {loadFiles} from "../../1. Core/ScriptLoader";


export default class JudgeTable extends Control {
	private _Instance: any;
	private _gridOptions: any;
	private _lbl: Label;
	private _noDataLabel: Label;


	_initFields(settings: object)
	{
		super._initFields(settings);
	}

	constructor(settings?: object)
	{
		super(settings);
		this._render();
	}

	_render()
	{
		this._initComponent('<div class="tech-table ag-theme-balham"></div>');

		this._lbl = new Label({
			ParentNode: this._root,
			RK: 'Judge report'
		});

		this._br();

		this._noDataLabel = new Label({
			ParentNode: this._root,
			RK: 'NoData'
		});

		this._noDataLabel.setIsVisible(false);

		if (this._ParentNode)
			this.putToNode(this._ParentNode);
	}

	refresh(slice: Slice, techData: number[][])
	{
		if (this._Instance)
			this._Instance.destroy();

		if (!(<any>window).AgGrid)
			return loadFiles(['ag-grid.js', 'ag-grid.css']).then(() => this.isLive() && this.refresh(slice, techData));

		let columnDefs: any[] = [];

		if (!slice || !slice.Data || slice.Data.length == 0)
		{
			this._noDataLabel.setIsVisible(true);
			return;
		}
		else
			this._noDataLabel.setIsVisible(false);

		// columnDefs.push({
		// 	headerName: NP.isTha() ? "" : NP.RM.getString("Round"),
		// 	width: 75
		// });

		for (let i = 0; i < slice.TopSlots.length; i += 2)
		{
			columnDefs.push({
				headerName: slice.TopSlots[i].split("-")[0],
				children: [{
					width: 95,
					headerName: NP.RM.getString("Red"),
					hType: 'RED'
				}, {
					width: 95,
					headerName: NP.RM.getString("Blue"),
					hType: 'BLUE'
				}]
			})
		}

		columnDefs.push({
			headerName: NP.RM.getString('TechnicalEvaluation'),
			children: [
				{headerName: NP.RM.getString("Red"), width: 70},
				{headerName: NP.RM.getString("Blue"), width: 70}
			]
		});

		let colIdx = this.setColField(columnDefs, 0);


		let rowData = [],
			 format = NP.getDefaultNumberFormat();

		// if (NP.isTha())
		// {
		// 	let res = {
		// 		0: NP.RM.getString("Total")
		// 	} as any;
			let res = [];

			slice.Data[0].forEach((cell: number, index: number) => res[index] = NP.applyFormat(cell, format, 1));

			let totalRow = techData[techData.length - 1];
			res[colIdx - 2] = totalRow[totalRow.length - 2];
			res[colIdx - 1] = totalRow[totalRow.length - 1];
			rowData.push(res);
		// }
		// else
		// 	for (let i = 0; i < slice.Data.length; i++)
		// 	{
		// 		let res = {0: slice.LeftSlots[0]} as any;
		//
		//
		// 		slice.Data[i].forEach((cell: number, index: number) => res[index + 1] = NP.applyFormat(cell, format, 1));
		// 		rowData.push(res);
		//
		// 		let teckRow = techData[i];
		// 		res[colIdx - 2] = teckRow[teckRow.length - 2];
		// 		res[colIdx - 1] = teckRow[teckRow.length - 1];
		// 	}

		this._Instance = new (window as any).AgGrid(this._root, this._gridOptions = {
			columnDefs: columnDefs,
			rowData: rowData,
			"headerHeight": 40,
			domLayout: 'autoHeight',
			"enableSorting": false,
			"animateRows": true,
			"enableColResize": false,
			"suppressPropertyNamesCheck": true,
			"suppressRowClickSelection": true,
			"suppressColumnVirtualisation": true,
			getRowStyle: function (params: any)
			{
				if (params.node.rowIndex % 2 == 0)
				{
					return {background: 'rgba(0, 0, 0, 0.12)'}
				}
			},
			onFirstDataRendered: (() =>
			{
				if (this._gridOptions)
					this._root.style.width = (this._root.querySelector(".ag-header-container") as HTMLElement).offsetWidth + 2 + 'px';
			})
		});
	}

	_cellGeneralStyleFunc(cell: any)
	{
		if (cell.colDef.hType == 'RED')
		{
			if (cell.data.redTechValue > parseFloat(cell.value))
				return {textAlign: 'center', backgroundColor: '#ffff00'};
		}
		else if (cell.colDef.hType == 'BLUE')
		{
			if (cell.data.blueTechValue > parseFloat(cell.value))
				return {textAlign: 'center', backgroundColor: '#ffff00'};
		}

		return {
			textAlign: 'center'
		};
	}


	setColField(columnDefs: any[], index: number)
	{
		for (let col of columnDefs)
		{
			if (col.children)
			{
				index = this.setColField(col.children, index);
			}
			else
			{
				col.field = "" + index++;
			}
			col.cellStyle = this._cellGeneralStyleFunc;
		}
		return index;
	}

	clear()
	{
		if (this._Instance)
		{
			this._Instance.destroy();
			this._Instance = null;
		}
	}
}